import type { TaskCreateFormType } from '@econtractor/types';
import TaskExecutorFlags from '../../shared/TaskExecutorFlags';
import TaskPayFields from '../../shared/TaskPayFields';

interface NewTaskAdditionalTabProps {
    values: TaskCreateFormType;
    setFieldValue: (field: string, value: unknown) => void;
    isSubmitting: boolean;
}

const NewTaskAdditionalTab = ({ values, setFieldValue, isSubmitting }: NewTaskAdditionalTabProps) => {
    return (
        <>
            <TaskPayFields
                idPrefix="new-task"
                disabled={isSubmitting}
                value={{
                    pay: Boolean(values.pay),
                    payAmount: values.payAmount ?? null,
                    payUsd: values.payUsd !== false,
                    showPayToExecutor: Boolean(values.showPayToExecutor),
                }}
                onChange={(next) => {
                    setFieldValue('pay', next.pay);
                    setFieldValue('payAmount', next.payAmount);
                    setFieldValue('payUsd', next.payUsd);
                    setFieldValue('showPayToExecutor', next.showPayToExecutor);
                }}
            />
            <TaskExecutorFlags
                idPrefix="new-task"
                disabled={isSubmitting}
                value={{
                    reserveExecutorTime: Boolean(values.reserveExecutorTime),
                    executorCanChangeTerm: Boolean(values.executorCanChangeTerm),
                    noEarlyStart: Boolean(values.noEarlyStart),
                }}
                onChange={(next) => {
                    setFieldValue('reserveExecutorTime', next.reserveExecutorTime);
                    setFieldValue('executorCanChangeTerm', next.executorCanChangeTerm);
                    setFieldValue('noEarlyStart', next.noEarlyStart);
                }}
            />
        </>
    );
};

export default NewTaskAdditionalTab;
